import { TFunction } from 'i18next';
import { GridEnrichedColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { AmountCell } from './component';
import { ReceiptsRowViewModel } from '../../row/viewModel';
import { ReceiptsCellViewModel } from '../viewModel';

export class AmountCellViewModel extends ReceiptsCellViewModel {
  constructor(row: ReceiptsRowViewModel) {
    super(row);
  }

  get t() {
    return this.row.translate;
  }

  get cellValue() {
    return this.receipt.amount.format();
  }

  get value() {
    return this.cellValue;
  }

  static buildColDef(t: TFunction): GridEnrichedColDef {
    return {
      field: 'amount',
      headerName: t('receipts:VALUE'),
      width: 110,
      filterable: false,
      renderCell: (params: GridRenderCellParams<AmountCellViewModel>) => <AmountCell {...params} />
    };
  }
}
